import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationHoverComponent } from './components/notification-hover/notification-hover.component';
import { NotificationCardComponent } from './components/notification-card/notification-card.component';
import { NotificationSidebarComponent } from './components/notification-sidebar/notification-sidebar.component';
import { NotificationHeaderButtonComponent } from './components/notification-header-button/notification-header-button.component';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '../core/core.module';
import * as fromNotifications from './store';
import { NotificationDisplayComponent } from './components/notification-display/notification-display.component';
import { ShareCommunicationModule } from '../sharing/sharing.module';
import { CommunicationsModule } from '../communications/communications.module';
import { QuillModule } from 'ngx-quill';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafeHtmlPipe } from '@app/shared/pipes/safe-html.pipe';

@NgModule({
  declarations: [NotificationHoverComponent, NotificationCardComponent, NotificationSidebarComponent, NotificationHeaderButtonComponent, NotificationDisplayComponent],
  imports: [
    CommonModule,
    ShareCommunicationModule,
    CommunicationsModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(fromNotifications.notificationsModuleKey, fromNotifications.reducers),
    EffectsModule.forFeature([fromNotifications.NotificationsEffects]),
    FlexLayoutModule,
    QuillModule,
    CoreModule,
    TranslateModule.forChild({
      extend: true
    }),
    SafeHtmlPipe
  ],
  exports: [NotificationHeaderButtonComponent]
})
export class NotificationsModule {}
